import { DBDef_ColorGroup, DBDef_DiseaseProfile } from '@app/dp-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_AdvisorStatic } from '../ModuleFE_AdvisorStatic.js';
import { allDPsId, generalDP, generalId } from '@app/advisor-shared';
import { MissingDataException } from '@nu-art/ts-common';
export const dispatch_onColorGroupChanged = new ThunderDispatcherV3('__onColorGroupUpdated');
class ModuleFE_Advisor_ColorGroup_Class extends ModuleFE_AdvisorStatic {
    diseaseProfileColorMap = {};
    constructor() {
        super(DBDef_ColorGroup, dispatch_onColorGroupChanged);
    }
    getColorForDiseaseProfile = (diseaseProfile) => {
        if (!diseaseProfile)
            return;
        if (!this.diseaseProfileColorMap[diseaseProfile._id])
            this.mapDiseaseProfileToColor(diseaseProfile);
        return this.diseaseProfileColorMap[diseaseProfile._id];
    };
    mapDiseaseProfileToColor = (diseaseProfile) => {
        const colorGroup = this.cache.unique(diseaseProfile.colorGroup);
        if (!colorGroup)
            throw new MissingDataException(`cannot find color group with id ${diseaseProfile.colorGroup}`);
        let idSum = 0;
        for (let i = 0; i < diseaseProfile._id.length; i++) {
            const c = diseaseProfile._id.charCodeAt(i);
            idSum += c <= 57 ? c - 48 : c <= 70 ? c - 55 : c - 87;
        }
        const index = idSum % 5;
        this.diseaseProfileColorMap[diseaseProfile._id] = colorGroup.colors[index];
    };
}
export const ModuleFE_Advisor_ColorGroup = new ModuleFE_Advisor_ColorGroup_Class();
export const dispatch_onDiseaseProfileChanged = new ThunderDispatcherV3('__onDiseaseProfileUpdated');
class ModuleFE_Advisor_DiseaseProfile_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_DiseaseProfile, dispatch_onDiseaseProfileChanged);
        const oldCacheUnique = this.cache.unique;
        this.cache.unique = _key => {
            if (typeof _key === 'string' && (_key === generalId || _key === allDPsId))
                return generalDP;
            return oldCacheUnique(_key);
        };
    }
}
export const ModuleFE_Advisor_DiseaseProfile = new ModuleFE_Advisor_DiseaseProfile_Class();
export const ModulePack_Static_DiseaseProfile = [
    ModuleFE_Advisor_ColorGroup,
    ModuleFE_Advisor_DiseaseProfile,
];
//# sourceMappingURL=disease-profile.js.map